module.exports = __webpack_public_path__ + "static/media/mileage.2f017397.svg";